import { DiscountElement } from "@redotech/redo-model/forge/review-forge-types";
import { memo, useContext } from "react";
import { Flex } from "../../flex";
import { InspectorConfig } from "../../inspector";
import { Text } from "../../text";
import {
  BrandKitContext,
  DiscountContext,
} from "../review-form-editor-contexts";

export const ReviewsDiscount = memo(function ReviewsLogo({
  element,
}: {
  element: DiscountElement;
}) {
  const brandKit = useContext(BrandKitContext);
  const discount = useContext(DiscountContext);
  const fontFamily = brandKit.font.fontFamily;

  if (!discount) {
    return null;
  }

  return (
    <Flex align="center" dir="column" justify="center" style={{ fontFamily }}>
      <Text
        fontSize="xs"
        isHeader
      >{`Enjoy ${discount.formattedDiscountString} off your next purchase with code`}</Text>
      <Text fontSize="xs" fontWeight="bold" isHeader>
        {discount.discountCode}
      </Text>
    </Flex>
  );
});

export const discountInspector: InspectorConfig<DiscountElement> = {
  sections: [],
};
